import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useOrganizationStore } from '@/store/modules/useOrganizationStore';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

export enum DateFormat {
  Default = 'MM/DD/YYYY',
  FullDate = 'MM/DD/YYYY hh:mm A',
  FullDateEu = 'MM/DD/YYYY HH:mm',
  YearMonthDay = 'YYYY-MM-DD',
  ISO = 'YYYY-MM-DDTHH:mm:ssZ[Z]',
  Time = 'HH:mm:ss',
}
export default function (
  value: dayjs.ConfigType,
  format: string = DateFormat.Default,
  useTimezone: boolean = true
) {
  if (!value) return;

  const organizationStore = useOrganizationStore();

  const date =
    !useTimezone || !organizationStore.currentOrganizationTimeZone
      ? dayjs(value)
      : dayjs(value).tz(organizationStore.currentOrganizationTimeZone);

  if (!date.isValid()) return value;

  return date.format(format);
}

export const isValidDate = (
  date: dayjs.ConfigType,
  format: DateFormat | string = DateFormat.ISO
) => {
  return dayjs(date, format).isValid();
};

export const formatDateUTC = (
  date: dayjs.ConfigType,
  format: DateFormat | string = DateFormat.Default
) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);

  if (!dayjsDate.isValid()) return date;

  return dayjsDate.utc().format(format);
};

export const formatDateWithTimezone = (
  date: dayjs.ConfigType,
  format: DateFormat | string = DateFormat.Default,
  timezone?: string
) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);

  if (!dayjsDate.isValid()) return date;

  return dayjsDate.tz(timezone).format(format);
};

export const formatDateSubOrganization = (
  date: dayjs.ConfigType,
  format: DateFormat | string = DateFormat.Default
) => {
  const organizationStore = useOrganizationStore();

  return formatDateWithTimezone(date, format, organizationStore.currentOrganizationTimeZone);
};
